import { render, staticRenderFns } from "./UtilitySeatingCarousel.vue?vue&type=template&id=af5eefc2&scoped=true&"
import script from "./UtilitySeatingCarousel.vue?vue&type=script&lang=js&"
export * from "./UtilitySeatingCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5eefc2",
  null
  
)

export default component.exports